import { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LaunchingSoon from "../components/Home/LaunchingSoon/LaunchingSoon";
import OurProcess from "../components/Home/OurProcess/OurProcess";
import Footer from "../components/Footer/PrelaunchFooter/Footer";
import Header from "../components/Header/PrelaunchHeader/Header";
import FoodInfo from "../components/Home/FoodInfo/FoodInfo";
import Ingredients from "../components/Home/Ingredients/Ingredients";
import ContactUs from "../components/Home/Ingredients/ContactUs";
import Manufacture from "../components/Home/Manufacture/Manufacture";
import AboutUs from "../components/Home/AboutUs/AboutUs";
import Navbar from "../components/Navbar/Navbar";
import Categories from "../components/Home/Categories/Categories";
import HeroSection from "../components/Home/HeroSection/HeroSection";
import SustainableGoals from "../components/Home/SustainableGoals/SustainableGoals";

const Homepage = () => {
  const aboutUsRef = useRef(null);
  const ourProcessRef = useRef(null);
  const manufactureRef = useRef(null);
  const ingredientsRef = useRef(null);
  const contactRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.section) {
      setShouldScroll(location.state.section); // Store the section name to scroll later
    }
  }, [location]);

  useEffect(() => {
    if (shouldScroll) {
      const sectionRefs = {
        "about-us": aboutUsRef,
        "our-process": ourProcessRef,
        "manufacture": manufactureRef,
        "ingredients": ingredientsRef,
        "contact-us": contactRef,
      };

      const sectionRef = sectionRefs[shouldScroll];

      if (sectionRef?.current) {
        setTimeout(() => {
          sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 500); // Ensure the DOM is fully loaded before scrolling
      }

      setShouldScroll(null); // Reset state after scrolling
    }
  }, [shouldScroll]);

  return (
    <>
      <Navbar
        aboutUsRef={aboutUsRef}
        ourProcessRef={ourProcessRef}
        manufactureRef={manufactureRef}
        ingredientsRef={ingredientsRef}
        contactRef={contactRef}
      />
      <HeroSection />
      <LaunchingSoon />
      <Categories />

      {/* Sections with refs */}
      <div ref={aboutUsRef}>
        <AboutUs />
      </div>
      <SustainableGoals />
      <FoodInfo />
      <div ref={ourProcessRef}>
        <OurProcess />
      </div>
      <div ref={manufactureRef}>
        <Manufacture />
      </div>
      <div ref={ingredientsRef}>
        <Ingredients />
      </div>
      <div ref={contactRef}>
        <ContactUs />
      </div>

      <Footer />
    </>
  );
};

export default Homepage;
